import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-mass-voucher-generator',
  templateUrl: './mass-voucher-generator.component.html',
  styleUrls: ['./mass-voucher-generator.component.scss']
})
export class MassVoucherGeneratorComponent {

  public data: any = {voucher_no: 300};
  public sections:any = []
  @ViewChild('f') f : NgForm

  constructor(private http: HttpService, private route: ActivatedRoute) { 
    this.initSection();
  }

  async initSection() {
    this.sections = await this.http.post("/admin/app/voucher/section/get");
  }

  async submit() {

    let y:any = await this.http.post("/admin/app/voucher/generate", this.data);

    if (y.status) {
      this.http.navigate(['/lo',this.http.getStaticSelectedCompany(),'setting-voucher'])
      return;
    }
    await this.f.resetForm({voucher_no: 300});
  }
}
